import { loadAccessControl } from '../accessControlStore';
import { getRegistryUsers, loadSessionRegistry } from '../sessionRegistry';
import { isCentralDbEnabled } from './config';
import { initCentralDbSync, pushUserToCentral } from './sync';
import { scheduleCatalogSync } from './syncCatalog';

export async function initCentralDatabase(): Promise<void> {
  if (!isCentralDbEnabled()) return;

  await initCentralDbSync();
  await loadAccessControl();
  await loadSessionRegistry();

  const { reloadAccessControl } = await import('../accessControlStore');
  await reloadAccessControl();

  const users = getRegistryUsers();
  await Promise.all(users.map((u) => pushUserToCentral(u)));

  // Kick an early catalog sync once global is ready
  scheduleCatalogSync();
}
